import classNames from 'classnames'
import { forwardRef, ThHTMLAttributes, useContext } from 'react'

import { TableContext } from './context'
import type { TableCellBaseProps } from './table-cell'
import styles from './table-column-header-cell.module.scss'

export type TableColumnHeaderCellElement = HTMLTableCellElement

export type TableColumnHeaderCellProps = ThHTMLAttributes<TableColumnHeaderCellElement> &
  TableCellBaseProps

const TableColumnHeaderCell = forwardRef<TableColumnHeaderCellElement, TableColumnHeaderCellProps>(
  function TableColumnHeaderCell(props, ref) {
    const { className, justify, ...rest } = props
    const { getCellStyles } = useContext(TableContext)

    const classes = classNames(getCellStyles({ justify }), styles.root, className)
    return <th scope="col" {...rest} className={classes} ref={ref} />
  }
)

export default TableColumnHeaderCell
